import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/constants/routes';
import { useTranslation } from '@/contexts';
import styles from './AccessDenied.module.css';

interface AccessDeniedProps {
  onBack?: () => void;
}

export function AccessDenied({ onBack }: AccessDeniedProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleBack = () => {
    if (onBack) {
      onBack();
      return;
    }
    navigate(ROUTES.DASHBOARD);
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <h1 className={styles.title}>{t('auth.accessDenied.title')}</h1>
        <p className={styles.subtitle}>{t('auth.accessDenied.subtitle')}</p>
        <button type="button" className={styles.backBtn} onClick={handleBack}>
          {t('auth.accessDenied.backToDashboard')}
        </button>
      </div>
    </div>
  );
}
